import React from "react";
import styles from "./second.module.scss";
import Carousel from "../../components/Carousel";

import Button, { BTN_VARIANTS } from "../../components/Button";
import { useNavigate } from "react-router-dom";
import ArrowRightIcon from "../../assets/icons/ArrowRight.icon";
import elements from "../../containers/Home/VPNSlides";

const Second = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [_, setSizes] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  React.useEffect(() => {
    window.addEventListener("resize", () =>
      setSizes({ height: window.innerHeight, width: window.innerWidth })
    );
    return () => {
      window.removeEventListener("resize", () =>
        setSizes({ height: window.innerHeight, width: window.innerWidth })
      );
    };
  }, []);
  return (
    <div className={styles.root}>
      <span className={styles.title}>
        Applications Built on <span className={"blue-text"}>Sentinel</span>
      </span>
      <section className={styles.carousel}>
        <Carousel elements={elements} />
      </section>
      <Button
        variant={BTN_VARIANTS.primary}
        className={styles["explore-all-btn"]}
        onClick={() => navigate("/dapps")}
      >
        <span>Explore All</span>
        <ArrowRightIcon />
      </Button>
    </div>
  );
};

export default Second;
